import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import ConversationLog from './projectmgmt/ConversationLog';
import MyLeads from './projectmgmt/MyLeads';
class ReportSettings extends Component {
   
    componentDidMount() {

        (function () {
            var currentPath = window.location.href;
            var currentPath = window.location.href;
            var path = window.origin + "/sales-desk/projectmgmt/reports";
            var path1 = window.origin + "/sales-desk/projectmgmt/reports/";
            var leadsPath = window.origin + "/sales-desk/projectmgmt/reports/myleads";
            if (currentPath === path || currentPath === path1) {
                $("#conv-log").addClass('active');
            } else if( currentPath === leadsPath ) {
                $("#lead-log").addClass('active');
            } else {
                $("#" + localStorage.getItem("last-report-data-tab")).addClass('active')
            }
            $("#conv-log,#lead-log")
                .on("click", function () {
                    $("#conv-log,#lead-log")
                        .removeClass('active');
                    localStorage.setItem("last-report-data-tab", $(this)[0].id);
                    $(this).addClass('active')

                })


        })();
    }

    render() {
        return (

            <div id="tabPage">
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <div className="content-header" >
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-5">
                                    <h1 className="m-0 page-title" >Reports</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container-fluid" >
                        {/* Nav tabs */}
                        <div className="border-bottom"></div>
                        <div className="tab-class">

                            <ul className="nav nav-tabs border-bottom navCluster">

                                <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/reports" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="conv-log" style={{ marginRight: '15px' }}>
                                        Conversation Log
                                    </li></Link>
                                
                              

                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route exact path="/projectmgmt/reports" component={ConversationLog}></Route>
                    
                </Switch>
            </div>

        );
    }
}
export default ReportSettings;




// WEBPACK FOOTER //
// ./src/sales-desk/ReportSettings.js